module.exports = __webpack_public_path__ + "assets/img/car18.dab82be3.jpg";